import Repository from '../../Repository';

const resource = '/d365/orders';

export default {
  getOrder(region, orderId) {
    let options = {};

    if (region !== null) {
      options.params = { region };
    }

    return Repository.get(`${resource}/${orderId}`, options);
  },
};
